export function formatTime(timestamp: Date | string | number): string {
  return new Date(timestamp).toTimeString().split(/\s/)[0];
}
